import { Toast } from "@newsela/angelou";

import { toastCss } from "./LogInPage.style";

export const EVENT_TOAST_ERROR = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Login error",
  __cssFor: toastCss,
};

export const ACCOUNT_LOCKED_ERROR =
  "Account locked: too many login attempts.  Please try again later.";
export const LOGIN_METHOD_NOT_ALLOWED =
  "Creating an account or signing in with Password is not allowed by your district.";
